import React from 'react';
import './Breadcrumbs.scss';
import { RouterLink } from '../ui';
import routes from '../../constants/routes.constant';

interface Props {
  order?: any;
  path?: string;
  background?: string;
}

const Breadcrumbs: React.FC<Props> = ({ order, path, background }) => {
  const build = [
    {
      label: 'Home',
      path: '/',
    },
  ];

  if (order) {
    if (order.frame?.genderName) {
      build.push({ label: 'Eyeglasses', path: '/eyeglasses' });
      build.push({ label: order.frame.genderName, path: '/mens' });
    }
  }

  if (path) {
    if (path.indexOf('/') === -1) {
      const route = routes.find(r => r.label === path);
      build.push({ label: route?.label || '', path: route?.path || '' });
    } else {
      const paths = path.split('/');
      paths.map(p => {
        build.push({ label: p, path: `/${p}` });
        return;
      });
    }
  }

  return (
    <>
      <div className={`breadcrumbs-block ${background ? background : ''}`}>
        {background ? (
          <div className="wrapper">
            <ul>
              {build.map((route, i) => {
                return (
                  <li key={i}>
                    <RouterLink path={route.path}>{route.label}</RouterLink>
                  </li>
                );
              })}
            </ul>
          </div>
        ) : (
          <ul>
            {build.map((route, i) => {
              return (
                <li key={i}>
                  <RouterLink path={route.path}>{route.label}</RouterLink>
                </li>
              );
            })}
            {order && order.frame ? (
              <li>
                <strong className="current-item">{`${order.frame.modelName} - ${order.frame.code}`}</strong>
              </li>
            ) : (
              ''
            )}
          </ul>
        )}
      </div>
    </>
  );
};

export default Breadcrumbs;
